module.exports = __webpack_public_path__ + "img/oneRed.1b5a8188.jpg";